<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!--Generated by IJSVG (https://github.com/iconjar/IJSVG)-->
    <defs>
      <path
        id="a"
        d="M11.5,14.5l7,-3v-10l-4,5l-3,-5l-3,5l-4,-5v10l7,3Z" />
      <path
        id="b"
        d="M19,23.5h-6l3.5,-5h6l-3.5,5Z" />
      <path
        id="c"
        d="M4,23.5h6l-3.5,-5h-6l3.5,5Z" />
    </defs>
    <g fill="#FFF">
      <use xlink:href="#a" />
      <use xlink:href="#b" />
      <use xlink:href="#c" />
    </g>
    <path
      class="st1"
      d="M22.5,18.5l-9.5,5h6l3.5,-5Z" />
    <g class="st1">
      <path d="M0.5,18.5l9.5,5h-6l-3.5,-5Z" />
      <path d="M17,10l-5.512,2.02l-4.988,-2.02l-2,1.5l6.988,3.02l7.012,-3.02l-1.5,-1.5Z" />
    </g>
    <use
      fill="none"
      class="st2"
      stroke-linejoin="round"
      stroke-width="1"
      xlink:href="#a" />
    <g
      stroke-linecap="round"
      stroke-width="1"
      class="st2"
      fill="none"
      stroke-linejoin="round">
      <path d="M11.5,14.5v9" />
      <use xlink:href="#b" />
      <use xlink:href="#c" />
      <path d="M10,23.5h3" />
    </g>
    <path
      fill="none"
      d="M0,0h24v24h-24Z" />
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .st1 {
    fill: var(--iconColorExtraLight);
  }

  .st2 {
    stroke: var(--iconColor);
  }
</style>
